import { useMemo } from 'react';
import { OrgUnitAssortment } from '@retail/mgpris/config-types';
import { useMyOrgUnitAssortments } from './MyOrgUnitAssortments';
import { useSelectedOrgUnit } from './SelectedOrgUnit';

const noCustomerAssortments: OrgUnitAssortment[] = [];

export const useCustomerAssortments = () => {
  const { selectedOrgUnitAssortment } = useSelectedOrgUnit();
  const { allAssortments } = useMyOrgUnitAssortments();

  return useMemo(
    () =>
      allAssortments.find(
        (assortment) => assortment.assortmentId === selectedOrgUnitAssortment.assortmentId
      )?.priceLists ?? noCustomerAssortments,
    [allAssortments, selectedOrgUnitAssortment.assortmentId]
  );
};
